{
  "adminSignInLink": {
    "body": "请点击下方按钮访问您的 Pointcare 管理门户。",
    "cta": "登录管理员账户",
    "greeting": "您好，",
    "ignore": "如果您没有请求管理员权限，可以忽略此邮件。",
    "linkFallback": "如果按钮无法使用，请复制并粘贴此链接：",
    "signoff": "谢谢，\nPointcare 团队",
    "subject": "您的 Pointcare 管理员登录链接"
  },
  "reset": {
    "body": "我们收到了重置您 Pointcare 账户密码的请求。请点击下方按钮创建新密码。",
    "cta": "重置我的密码",
    "greeting": "您好，",
    "ignore": "如果您没有提出此请求，可以放心忽略此邮件。您的密码不会更改。",
    "signoff": "谢谢，\nPointcare 团队",
    "subject": "重置您的 Pointcare 密码"
  },
  "signInLink": {
    "body": "请点击下方按钮确认您的邮箱并设置您的 Pointcare 账户。",
    "cta": "确认我的邮箱",
    "greeting": "您好，",
    "ignore": "没有注册 Pointcare？您可以忽略此邮件。",
    "linkFallback": "如果按钮无法使用，请复制并粘贴此链接：",
    "signoff": "谢谢，\nPointcare 团队",
    "subject": "确认您的 Pointcare 邮箱"
  }
}
